import { CSRFTOKEN } from "../redux/constant/constants";
import axios from 'axios';
import { navigateToLoginPage } from "PublishedNew/components/withAuth";

export async function getSystemIcons(){
    const config ={
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        }
    }
    const response = await fetch('/api/system_markers/',config);
    return await response.json();
}

export async function getUserIcons(){
    const config ={
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        }
    }
    const response = await fetch('/api/user_markers/',config);
    return await response.json();
}

export async function getSavedButtons(){
    const config ={
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        }
    }
    const response = await fetch('/api/saved_buttons/',config);
    return await response.json();
}

export async function createSavedButton( data ){
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/saved_buttons/', config);
    return await response.json();
}

export async function deleteSavedButton( id ){
    const config = {
        method: 'DELETE',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify({id})
    }
    const response = await fetch('/api/saved_buttons/', config);
    return await response.json();
}

export async function getBrand( userId ){
    const config ={
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        }
    }
    const response = await fetch(`/api/getbrand/${userId}/`,config);
    return await response.json();
}

export async function getLogoClients( data ){
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/clientimgdownload/', config);
    return await response.json();
}

export async function getClients( data ){
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/clientdownload/', config);
    return await response.json();
}

export async function deletePanelumImage( data ){
    const config = {
        method: 'DELETE',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            "Content-type": "application/json"
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/panelum/', config);
    return await response.json();
}


export async function deleteMultiImage( data ){
    const config = {
        method: 'DELETE',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            "Content-type": "application/json"
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/imageupload/', config);
    return await response.json();
}

export async function deleteSinglePlan( data ){
    const config = {
        method: 'DELETE',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            "Content-type": "application/json"
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/imageplanuload/', config);
    return await response.json();
}

export async function deleteSimpleImage( data ){
    const config = {
        method: 'DELETE',
        headers: {
            "X-CSRFToken": CSRFTOKEN
        },
        body: data
    }
    const response = await fetch('/api/imageupload/', config);
    return await response.json();
}

export async function createNewPlan( data ){
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/create/?token=1234567', config);
    return await response.json();
}

export async function updateNewPlan(data) {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'X-CSRFToken': CSRFTOKEN,
        'content-type': 'application/json',
      },
      body: JSON.stringify(data),
    };
    const response = await fetch('/api/ifloorplans/' + data.id + '/', config);
    if (response.status === 200) {
      return await response.json();
    } else {
      navigateToLoginPage();
    }
  } catch (error) {
    console.log('🚀 | file: requests.js | line 150 | error', error);
  }
}

export async function uploadFilesToServer(url, file, config){
    const response = await axios.post(url, file, config);
    return await response;
}

export async function getImages(url, file, config){
    const response = await axios.get(url, file, config);
    return await response;
}

export async function uploadFilesToServerPanelum(url, file, config){
    const response = await axios.put(url, file, config);
    return await response;
}

export async function updateSingleImage(url, file, config){
    const response = await axios.put(url, file, config);
    return await response;
}


export async function getTemplates( data ){
    const config = {
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
    }
    const response = await fetch('/api/ifloorplans/', config);
    return await response.json();
}

export async function getCurrentUser(){
    const config = {
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
    }
    const response = await fetch('/api/getcurrentuser/', config);
    return await response.json();
}

export async function updateImageIndex(data){
    const config = {
        method: 'PUT',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/imageupload/', config);
    return await response;
}
